export default {
  hero: {
    breadcrumbs: {
      home: 'Ana Sayfa',
      properties: 'İlanlar'
    }
  },
  property: {
    title: 'Başlık',
    description: 'Açıklama',
    price: 'Fiyat',
    price_currency: 'Para birimi',
    gross_area: 'Brüt alan',
    net_area: 'Net alan',
    floor: 'Kat',
    total_floors: 'Toplam kat sayısı',
    rooms: 'Oda sayısı',
    layout_type: 'Plan tipi',
    status: 'Mülkün durumu',
    purpose: 'Kullanım amacı',
    ownership: 'Mülkiyet hakkı',
    heating: 'Isıtma tipi',
    orientation: 'Yön',
    view: 'Manzara',
    address: 'Adres',
    year_of_construction: 'Yapım yılı',
    location: 'Konum',
    video: 'Video tanıtım',
    features: 'Özellikler',
    contact_agent: 'Emlak danışmanı ile iletişime geçin',
    request_price: 'Güncel fiyatı iste',
    back_to_all: '← Tüm ilanlara geri dön',
    developer: 'Müteahhit',
    residential_complex: 'Konut projesi',
    building: 'Bina',
    ai_prediction: 'Yapay zeka değerlendirmesi',
    evaluation_chart: 'Değerlendirme grafiği',
    map: 'Harita',
    gallery: 'Galeri',
    video_tour: 'Video turu',
    loading: 'Daire verileri yükleniyor...',
    catalog_id: 'Katalog numarası',
    layout_type_label: 'İlan türü',
    status_label: 'Durum',
    purpose_label: 'Kullanım amacı',
    heating_label: 'Isıtma',
    orientation_label: 'Yön',
    building_type_label: 'Bina tipi',
    view_label: 'Manzara',
    citizenship_available: 'Vatandaşlık için uygun',
    mortgage_available: 'Krediye uygun',
    not_specified: 'Belirtilmemiş',

    // PropertyCharacteristics'ten
    country: 'Ülke',
    region: 'Bölge',
    city: 'Şehir',
    district: 'Semt',
    residential_complex_label: 'Konut projesi',
    building_label: 'Bina',
    rooms_label: 'Oda sayısı',
    floor_label: 'Kat',
    total_floors_label: 'Binadaki toplam kat',
    gross_area_label: 'Brüt alan',
    net_area_label: 'Net alan',
    year_of_construction_label: 'Yapım yılı',
    heating_label_fallback: 'Isıtma',
    orientation_label_fallback: 'Yön',
    building_type_label_fallback: 'Bina tipi',
    view_label_fallback: 'Manzara',

    gallery_title: 'Mülk fotoğrafları',

    agent: {
      full_name: 'Danışman',
      agency: 'Emlak ofisi',
      phone: 'Telefon'
    },

    amenities: {
      title: 'Olanaklar',
      empty: 'Olanak belirtilmemiş'
    },

    characteristics: {
      title: 'Özellikler',
      loading: 'Özellikler yükleniyor...'
    },

    video: {
      no_video: 'Video mevcut değil'
    },

    unpublished: {
      title: '🏗️ İlan yayımlanmadı',
      message: 'Daire halka açık görüntüleme için uygun değil.',
      location: 'Konum',
      home: 'Ana sayfa'
    }
  }
}
